import { combineSlices } from "@reduxjs/toolkit";
import { activeSectionSlice } from "./activeSectionSlice";
import { activeAnimalSlice } from "./activeAnimalSlice";

export const stateSlice = combineSlices({
  section: activeSectionSlice.reducer,
  activeAnimal: activeAnimalSlice.reducer
})